import { z } from 'zod';
import httpClient from '@/src/lib/api/http/client';
import { SCartResponse, TCartResponse } from '../data/schemas';
import { IGetCartParams } from '../data/schemas/request';

export const CartService = {
  getCart: async ({ user_id }: IGetCartParams): Promise<TCartResponse> => {
    const response = await httpClient.healthyoneTransaction.get(
      `/cart/b2c?find=cart&user=${user_id}`,
      { timeout: 60_000 }
    );
    const result = SCartResponse.safeParse(response.data);
    return result.success ? result.data : (response.data as TCartResponse);
  },

  getCartCount: async ({ user_id }: IGetCartParams): Promise<number> => {
    const response = await httpClient.healthyoneTransaction.get(
      `/cart/b2c?count=cart&user=${user_id}`
    );
    const result = z.number().safeParse(response.data);
    return result.success ? result.data : Number(response.data) || 0;
  },
};
